import React from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import Parser from "html-react-parser";

const SignUpFail = () => {
        const { type } = useParams() // type 1, 2 are version 1 phone pass auth errors so not used in version 2. Only type 3 is used
    const navigate = useNavigate()

    return (
        <>
            {type === '3' ?
                <motion.div className='h-screen flex flex-col justify-center items-center px-8 py-4'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ ease: "easeOut", duration: 1 }}>
                    <img src='/images/mobile/image/lock.svg' alt={"Lock image"} className='flex flex-col justify-center items-center mx-auto' />
                    <p className='text-subtitle_1 font-bold text-gray_160 mt-6 mb-24'>
                        {"Verification Failed"}<br />
                        {Parser("This account doesn't have a phone number associated with it.<br/>Please try signing up with a different method.")}
                    </p>
                    <p onClick={() => navigate(`/sign`)} className='flex justify-center items-center gap-2 text-caption_1 font-semibold text-gray_160 mt-4'>
                        <span>{"Back to Start"}</span>
                        <img src='/images/mobile/icon/arrow_right.svg' alt={"Arrow icon"} className='w-3 h-3' />
                    </p>
                </motion.div>
                : <motion.div className='h-screen flex flex-col justify-center items-center px-8 py-4'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ ease: "easeOut", duration: 1 }}>
                    <img src='/images/mobile/image/lock.svg' alt={"Lock image"} className='flex flex-col justify-center items-center mx-auto' />
                    <p className='text-subtitle_1 font-bold text-gray_160 mt-6 mb-24'>
                        {Parser("You're already registered!<br/>Please log in instead.")}
                    </p>
                    <p onClick={() => navigate(`/sign`)} className='flex justify-center items-center gap-2 text-caption_1 font-semibold text-gray_160 mt-4'>
                        <span>{"Back to Start"}</span>
                        <img src='/images/mobile/icon/arrow_right.svg' alt={"Arrow icon"} className='w-3 h-3' />
                    </p>
                </motion.div>}
        </>

    );
};

export default SignUpFail;
